<template>
  <div>
    <a
      :href="open()"
      class="bt-whatsApp"
      target="_blank"
      style="
        right: 25px;
        position: fixed;
        width: 60px;
        height: 22px;
        bottom: 40px;
        z-index: 100;
      "
    >
      <img
        src="../../../static/images/whatsApp.svg"
        alt=""
        width="60px"
      />
    </a>
    <div
      id="msg1"
      style="
        right: 90px;
        visibility: visible;
        background: #fff;
        color: #000;
        position: fixed;
        width: 200px;
        bottom: 5px;
        text-align: center;
        font-size: 13px;
        line-height: 31px;
        height: 32px;
        border-radius: 100px;
        z-index: 100;
        border: 1px solid #ccc;        
      "
    >
      Prosseguir com Atendimento
    </div>
  </div>
</template>

<script>
export default {
    props:{
        id: null
    },
    methods:{
        open(){            
          return "https://api.whatsapp.com/send/?phone=554934255400&text=Gostaria+de+prosseguir+com+simula%C3%A7%C3%A3o+GIGA+AUTO+ "+ this.id +"&type=phone_number&app_absent=0";
        }
    }

};
</script>


// WEBPACK FOOTER //
// src/views/terceiros/btnWhatsApp.vue